<script>
import { Doughnut, mixins } from "vue-chartjs";
import { getRandomColor, fetchDataCommands } from "../base";

export default {
  extends: Doughnut,
  mixins: [mixins.reactiveData],
  data() {
    return {
      chartData: "",
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  async created() {
    await fetchDataCommands()
      .then((response) => {
        this.chartData = response;
      })
      .catch((error) => {
        console.log(error);
        alert("Error: " + error);
      });

    const data = this.chartData;
    //map all user data to array
    //const user = data.cmd.map((user) => user.count);
    //tambahkan semua value
    //const total = user.reduce((a, b) => a + b, 0);
    //console.log(total);
    

    this.chartData = {
      //get all keys from user object
      //labels: Object.keys(user),
      labels: [data.cmd[0].command, data.cmd[1].command, data.cmd[2].command, data.cmd[3].command, data.cmd[4].command, data.cmd[5].command, data.cmd[6].command, data.cmd[7].command, data.cmd[8].command, data.cmd[9].command, data.cmd[10].command, data.cmd[11].command, data.cmd[12].command, data.cmd[13].command, data.cmd[14].command],
      datasets: [
        {
          backgroundColor: [
            getRandomColor(),
            getRandomColor(),
            getRandomColor(),
            getRandomColor(),
            getRandomColor(),
            getRandomColor(),
            getRandomColor(),
            getRandomColor(),
            getRandomColor(),
            getRandomColor(),
            getRandomColor(),
            getRandomColor(),
            getRandomColor(),
            getRandomColor(),
            getRandomColor(),
           
          ],
          data: [data.cmd[0].count, data.cmd[1].count, data.cmd[2].count, data.cmd[3].count, data.cmd[4].count, data.cmd[5].count, data.cmd[6].count, data.cmd[7].count, data.cmd[8].count, data.cmd[9].count, data.cmd[10].count, data.cmd[11].count, data.cmd[12].count, data.cmd[13].count, data.cmd[14].count]
        }
      ]
    };
  }
};
</script>